export default function getProducts(room, austattung_produkt, products, isUmbau = false){

    const productList = [];
    let combinations = [];
    let productList_optional = [];
// console.log('addDosenRahmen starting with', room.name, 'schaltbare',products.schaltbare,'normal',products.normal,'daten',products.daten, isUmbau)
    if (isUmbau) {

        let count_telefon_datenanschluss = 0;
        let count_telefonanschlusss = 0;
        let count_radio_datenanschluss_sat = 0;
        let count_radio_datenanschluss_kabel = 0;

        if(
            room.selectedEquipment["telefon_datenanschluss"] !== undefined
            && room.selectedEquipment["telefon_datenanschluss"] > 0
        ){
            count_telefon_datenanschluss += room.selectedEquipment["telefon_datenanschluss"];
        }
        if(
            room.selectedEquipment["telefonanschlusss"] !== undefined
            && room.selectedEquipment["telefonanschlusss"] > 0
        ){
            count_telefonanschlusss += room.selectedEquipment["telefonanschlusss"];
        }
        if(
            room.selectedEquipment["radio_datenanschluss_sat"] !== undefined
            && room.selectedEquipment["radio_datenanschluss_sat"] > 0
        ){
            count_radio_datenanschluss_sat += room.selectedEquipment["radio_datenanschluss_sat"];
        }
        if(
            room.selectedEquipment["radio_datenanschluss_kabel"] !== undefined
            && room.selectedEquipment["radio_datenanschluss_kabel"] > 0
        ){
            count_radio_datenanschluss_kabel += room.selectedEquipment["radio_datenanschluss_kabel"];
        }

        let frameCount1 = 0;
        let frameCount2 = 0;
        let frameCount3 = 0;
        let frameCount4 = 0;

        while(
            count_telefon_datenanschluss > 0
            || count_telefonanschlusss > 0
            || count_radio_datenanschluss_sat > 0
            || count_radio_datenanschluss_kabel > 0
            ){
            let frameSize = 0;
            if(count_telefon_datenanschluss > 0){
                frameSize++;
                count_telefon_datenanschluss--;
            }
            if(count_telefonanschlusss > 0){
                frameSize++;
                count_telefonanschlusss--;
            }
            if(count_radio_datenanschluss_sat > 0){
                frameSize++;
                count_radio_datenanschluss_sat--;
            }
            if(count_radio_datenanschluss_kabel > 0){
                frameSize++;
                count_radio_datenanschluss_kabel--;
            }

            switch(frameSize){
                case 1:
                    frameCount1++;
                    break;
                case 2:
                    frameCount2++;
                    break;
                case 3:
                    frameCount3++;
                    break;
                case 4:
                    frameCount4++;
                    break;
                default:
            }
        }

        [
            {key: "r-4f", count: frameCount4, factor: 4},
            {key: "r-3f", count: frameCount3, factor: 3},
            {key: "r-2f", count: frameCount2, factor: 2},
            {key: "r-1f", count: frameCount1, factor: 1}
        ].forEach(frame => {
            if(
                frame.count > 0
                && austattung_produkt[frame.key] !== undefined
            ){
                productList_optional.push({
                    product: austattung_produkt[frame.key],
                    count: frame.count,
                    factor: frame.factor
                });
            }
        });
    }
    else {

        let count_telefon = 0;
        let count_radio = 0;

        if(
            room.selectedEquipment["telefon_datenanschluss"] !== undefined
            && room.selectedEquipment["telefon_datenanschluss"] > 0
        ){
            count_telefon += room.selectedEquipment["telefon_datenanschluss"];
        }
        if(
            room.selectedEquipment["telefonanschlusss"] !== undefined
            && room.selectedEquipment["telefonanschlusss"] > 0
        ){
            count_telefon += room.selectedEquipment["telefonanschlusss"];
        }
        if(
            room.selectedEquipment["radio_datenanschluss_sat"] !== undefined
            && room.selectedEquipment["radio_datenanschluss_sat"] > 0
        ){
            count_radio += room.selectedEquipment["radio_datenanschluss_sat"];
        }
        if(
            room.selectedEquipment["radio_datenanschluss_kabel"] !== undefined
            && room.selectedEquipment["radio_datenanschluss_kabel"] > 0
        ){
            count_radio += room.selectedEquipment["radio_datenanschluss_kabel"];
        }
        // console.log('count telefon', count_telefon, 'count radio', count_radio);
        let frameCount1 = 0;
        let frameCount2 = 0;
        let frameCount3 = 0;

        while(count_telefon > 0 || count_radio > 0) {
            let frameSize = 0;
            if(count_telefon > 0){frameSize++;count_telefon--;}
            if(count_radio > 0){frameSize++;count_radio--;}
            switch(frameSize){
                case 1:frameCount1++;break;
                case 2:frameCount2++;break;
                case 3:frameCount3++;break;
                default:
            }
        }

        let counter_telefon = products.daten.telefon.length;
        let counter_radio = products.daten.radio.length;

        // console.log('counter_telefon', counter_telefon, 'counter_radio', counter_radio)

        let frames_list = [
            {key: "r-3f", count: frameCount3, factor: 3},
            {key: "r-2f", count: frameCount2, factor: 2},
            {key: "r-1f", count: frameCount1, factor: 1}
        ];
        // console.log('frames_list', frames_list)

        frames_list.forEach((frame, fIdx) => {
            if(frame.count > 0 && austattung_produkt[frame.key] !== undefined) {
                const frameCount = frame.count;
                if (products.normal.length > 0) { frame = frames_list[fIdx - 1]; }
                productList.push({
                    product: austattung_produkt[frame.key],
                    count: frameCount,
                    factor: frame.factor
                });
                for (let i = 0; i < frameCount; i++) {
                    let comb = {
                        frame: austattung_produkt[frame.key],
                        factor: 1,
                        orientation: 'H',
                        controlElements: [],
                        origin: 'addDosenRahmen, 177'
                    };

                    const product1 = products.normal.shift();
                    let product2; let product3;
                    comb.controlElements.push({position: 1, insert: product1});
                    switch (frame.factor) {
                        case 2:
                            if (counter_telefon > 0) { product2 = products.daten.telefon.shift(); counter_telefon -= 1; }
                            else if (counter_radio > 0) { product2 = products.daten.radio.shift(); counter_radio -= 1; }
                            if (product2) { comb.controlElements.push({position: 2, insert: product2[0], abdeckung: product2[1]}); }
                            else if (products.normal.length) {
                                product2 = products.normal.shift();
                                comb.controlElements.push({position: 2, insert: product2});
                            }
                            break;
                        case 3:
                            if (counter_telefon > 0) { product2 = products.daten.telefon.shift(); counter_telefon -= 1; }
                            else if (counter_radio > 0) { product2 = products.daten.radio.shift(); counter_radio -= 1; }
                            if (product2) { comb.controlElements.push({position: 2, insert: product2[0], abdeckung: product2[1]}); }
                            else if (products.normal.length) {
                                product2 = products.normal.shift();
                                comb.controlElements.push({position: 2, insert: product2});
                            }

                            if (counter_radio > 0) { product3 = products.daten.radio.shift(); counter_radio -= 1; }
                            if (product3) { comb.controlElements.push({position: 3, insert: product3[0], abdeckung: product3[1]}); }
                            else if (products.normal.length) {
                                product3 = products.normal.shift();
                                comb.controlElements.push({position: 2, insert: product3});
                            }
                            break;
                        default:
                    }
                    combinations.push(comb);
                    // console.log('pushed combination', comb)
                }
            }
        });
    }

    // console.log('after telefon and radio', products);
    let count_steckdosen = products.normal.length;
    let count_steckdosen_schaltbar = products.schaltbare.length;
    let total_steckdosen = count_steckdosen + count_steckdosen_schaltbar;
    let frameCount1 = 0; let frameCount2 = 0; let frameCount3 = 0;
    // console.log('remaining steckdosen', room.name, 'normal', products.normal.length, 'schaltbar', products.schaltbare.length);

    while (count_steckdosen + count_steckdosen_schaltbar >= 3) {frameCount3++;count_steckdosen -= 3;}
    while (count_steckdosen + count_steckdosen_schaltbar >= 2) {frameCount2++;count_steckdosen -= 2;}
    while (count_steckdosen + count_steckdosen_schaltbar >= 1) {frameCount1++;count_steckdosen -= 1;}
    let frames_list = [];
    frames_list = [
        {key: "r-3f", count: frameCount3, factor: 3},
        {key: "r-2f", count: frameCount2, factor: 2},
        {key: "r-1f", count: frameCount1, factor: 1}
    ];

    total_steckdosen = frameCount1 + frameCount2 + frameCount3;
    // console.log('frames_list', frames_list, 'normal.count', products.normal.length, 'schaltbare count', products.schaltbare)
    const addSteckdosenFrames = function() {
        frames_list.forEach(frame => {
            if(frame.count > 0 && austattung_produkt[frame.key] !== undefined) {
                productList.push({
                    product: austattung_produkt[frame.key],
                    count: frame.count,
                    factor: frame.factor
                });
                for (let cc = 0; cc < frame.count; cc++) {
                    let comb = {
                        frame: austattung_produkt[frame.key],
                        factor: 1,
                        orientation: 'H',
                        controlElements: [],
                        origin: 'addDosenRahmen, 256'
                    };
                    for (let k = 0; k < frame.factor; k++) {
                        let sdose = products.normal.shift();
                        if (sdose === undefined) {
                            sdose = products.schaltbare.shift();
                        }
                        comb.controlElements.push({
                            position: k + 1,
                            insert: sdose
                        });
                        total_steckdosen -= 1;
                    }
                    combinations.push(comb);
                    // console.log('pushed combination',comb, cc, frame.count, frame.key)
                }
            }
        });
    };
    addSteckdosenFrames();
    if (total_steckdosen > 0) { addSteckdosenFrames(); }

    // console.log('addDosenRahmen returning', {productList, combinations});

    // console.log('products.charger', products.charger)
    const chargerFrames = [];
    products.charger.forEach(p => {
        const frame = {key: "r-1f", count: 1, factor: 1};
        let comb = {
            frame: austattung_produkt[frame.key],
            factor: 1,
            orientation: 'H',
            controlElements: [],
            origin: 'addDosenRahmen, 282'
        };
        for (let k = 0; k < frame.factor; k++) {
            if (p.indexOf('|') < 0) {
                comb.controlElements.push({
                    position: k + 1,
                    insert: p
                });
            } else {
                const pp = p.split('|');
                comb.controlElements.push({
                    position: k + 1,
                    insert: pp[0],
                    abdeckung: pp[1]
                });
            }
        }
        chargerFrames.push({
            product: austattung_produkt[frame.key],
            count: frame.count,
            factor: frame.factor
        });
        combinations.push(comb);
    });

    return {productList, productList_optional, combinations, chargerFrames};
}
